<template>
  <a-form :form="form" @submit="handleSubmit">
    <a-form-item label="旧密码" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
      <a-input
        v-decorator="[
          'oldPassword',
          { rules: [{ required: true, message: '请输入旧密码!' }] },
        ]"
        type="password"
      />
    </a-form-item>
    <a-form-item label="新密码" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
      <a-input
        v-decorator="[
          'newPassword',
          {
            rules: [
              { required: true, message: '请输入新密码!' },
              {
                validator: vPassword,
              },
            ],
          },
        ]"
        :type="passType"
      >
        <a-icon
          slot="suffix"
          type="eye"
          style="cursor: pointer"
          @mousedown="onShowPassword"
          @mouseup="onHidePassword"
        />
      </a-input>
    </a-form-item>
    <a-form-item label="确认密码" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
      <a-input
        v-decorator="[
          'confirmPassword',
          {
            rules: [
              { required: true, message: '请输入确认密码!' },
              {
                validator: validatePassword,
              },
            ],
          },
        ]"
        :type="rePassType"
      >
        <a-icon
          slot="suffix"
          type="eye"
          style="cursor: pointer"
          @mousedown="onShowRePassword"
          @mouseup="onHideRePassword"
        />
      </a-input>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 17, offset: 6 }">
      <a-button type="primary" html-type="submit">提交</a-button>
    </a-form-item>
  </a-form>
</template>
<script>
export default {
  data() {
    return {
      passType: "password",
      rePassType: "password",
      form: this.$form.createForm(this),
      referer: "",
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // eslint-disable-next-line
          this.axios
            .post(
              "web/users/updPassWord2/" +
                this.user.id ,{username:
                this.user.username,password:values.newPassword,oldPassword:values.oldPassword}
            )
            .then((res) => {
              if(res.data !=1 && !res.data.success) {
                if(!res.data.msg) {
                  this.$message.error("密码修改失败！");
                }
                else {
                  this.$message.error(res.data.msg);
                }
              }else {
                this.$message.success("密码修改成功！您需要重新登录！");
                sessionStorage.clear();
                this.$router.push("/login");
              }
              
            }).catch(() => {
              this.$message.error("密码修改失败！");
            });
        }
      });
    },
    validatePassword(rule, value, callback) {
      const values = this.form.getFieldsValue();
      if (values.newPassword != values.confirmPassword) {
        callback("两次密码不一致！");
      } else {
        callback();
      }
    },
    vPassword(rule, value, callback) {
      const values = this.form.getFieldsValue();
      var pwdRegex = new RegExp(
        "(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,30}"
      );
      if (!pwdRegex.test(values.newPassword)) {
        callback(
          "您的密码复杂度太低（密码中必须包含大小写字母、数字、特殊字符，至少8个字符，最多30个字符。）！"
        );
      } else {
        callback();
      }
    },
    onShowPassword() {
      this.passType = "text";
    },
    onHidePassword() {
      this.passType = "password";
    },
    onShowRePassword() {
      this.rePassType = "text";
    },
    onHideRePassword() {
      this.rePassType = "password";
    },
  },
};
</script>
<style></style>
